"use client";

import ForgotPasswordForm from '../../../../src/components/auth/forgot-password-form';
import Link from 'next/link';
import { PublicPageLayout } from "@letsgo/PublicPageLayout";
import { Box, Link as MuiLink } from '@mui/material';

export default function ForgotPasswordPage() {
  return (
    <PublicPageLayout>
      <Box
        sx={{
          minHeight: '80vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 3,
          py: 4,
          px: 2,
        }}
      >
        <ForgotPasswordForm />
        <MuiLink component={Link} href="/auth" variant="body2" sx={{ mt: 1 }}>
          Back to sign in
        </MuiLink>
      </Box>
    </PublicPageLayout>
  );
}
